import {all} from "redux-saga/effects";
import {combineReducers} from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import * as customer from "../app/customer/_redux/customerRedux";
import * as admin from "../app/admin/_redux/adminRedux";
import * as notif from '../_metronic/_partials/notification/NotificationRedux';
import * as actionsLoading from './ActionsLoadingRedux';

export const rootReducer = combineReducers({
    auth: auth.reducer,
    customer: customer.reducer,
    admin: admin.reducer,
    notification: notif.reducer,
    actionsLoading: actionsLoading.reducer
});

export function* rootSaga() {
    yield all([auth.saga()]);
}
